import React, { useEffect, useState } from "react";
import UsersRequests from "services/users";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";

import makeStyles from "@material-ui/core/styles/makeStyles";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import {
  Box,
  Checkbox,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import Button from "@material-ui/core/Button";
import { Create } from "@material-ui/icons";
import GridContainer from "@jumbo/components/GridContainer";

import CmtCard from "@coremat/CmtCard";
import CmtCardContent from "@coremat/CmtCard/CmtCardContent";
import getProfileImage from "@jumbo/utils/hooks/getProfileImage";
import ChangeProfileDialog from "./UserProfileSelector";

const useStyles = makeStyles((theme) => ({
  formControl: {
    width: "100%",
  },
  cardRoot: {
    paddingTop: "24px",
    [theme.breakpoints.down("xs")]: {
      "& .Cmt-header-root": {
        flexDirection: "column",
      },
      "& .Cmt-action-default-menu": {
        marginLeft: 0,
        marginTop: 10,
      },
    },
  },
  cardContentRoot: {
    padding: 0,
  },
  formContainer: {
    width: "100%",
  },
  girdContainer: {
    width: "100%",
    margin: "0",
    padding: "0",
  },
  customInput: {
    width: "80%",
    [theme.breakpoints.down("lg")]: {
      width: "100%",
    },
  },
  inputContainer: {
    paddingInline: "40px !important",
    "& p": {
      fontWeight: "bold",
      marginBottom: "16px",
    },
  },
  buttonContainer: {
    paddingInline: "40px !important",
    justifyContent: "flex-end",
  },
  ProfileImageContainer: {
    width: 130,
    height: 130,
    borderRadius: "50%",
    marginInline: "auto",
    position: "relative",
    overflow: "hiedden",
    "& img": {
      width: "100%",
      height: "100%",
    },
  },
  editContainer: {
    position: "absolute",
    bottom: 10,
    left: 5,
    width: 30,
    height: 30,
    background: theme.palette.background.paper,
    boxShadow: "0 1rem 3rem rgba(0, 0, 0, 0.3)",
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    color: theme.palette.primary.main,
  },
}));

const UpdateUserContainer = () => {
  const [profileImg, setProfileImg] = useState("");
  const [userName, setUserName] = useState("");
  const [userId, setUserId] = useState("");
  const [nationalCode, setNationalCode] = useState("");
  const [personalCode, setPersonalCode] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [userRole, setUserRole] = useState("");
  const [passWord, setPassWord] = useState("");
  const [coin, setCoin] = useState("");
  const [passRepeat, setPassRepeat] = useState("");
  const [openUpdateDialog, setOpenUpdateDialog] = useState(false);
  const [associationType, setAssociationType] = useState("");
  const [lock, setLock] = useState(false);
  const [lockReason, setLockReason] = useState("");
  // const [userEnabled, setUserEnabled] = useState(false);
  const classes = useStyles();
  const dispatch = useDispatch();
  const { id } = useParams();
  const { userByID } = useSelector(({ users }) => users);

  useEffect(() => {
    dispatch(UsersRequests.getUserById(id));
  }, [id]);

  useEffect(() => {
    if (userByID) {
      setUserId(userByID._id);
      setProfileImg(userByID.profileImage);
      setUserName(userByID.fullName);
      setNationalCode(userByID.nationalCode);
      setPersonalCode(userByID.personnelCode);
      setPhoneNumber(userByID.phone);
      setUserRole(userByID.relation);
      setCoin(userByID.coin);
      setAssociationType(userByID.associationType);
      setLock(userByID.lock);
      setLockReason(userByID.lockReason);
    }
  }, [userByID]);

  const handleUpdateUser = () => {
    if (userName && nationalCode && personalCode && phoneNumber && userRole) {
      const userData = {
        profileImage: profileImg,
        fullName: userName,
        nationalCode: nationalCode,
        personnelCode: personalCode,
        phone: phoneNumber,
        relation: userRole,
        coin: coin,
        associationType: associationType,
        lock: lock,
        lockReason: lockReason,
      };
      dispatch(UsersRequests.updateSingleUser(userData, id));
    }
  };

  const handleUpdatePassword = () => {
    if (passWord && passRepeat) {
      dispatch(UsersRequests.updateUserPass(passWord, passRepeat, id));
    }
  };
  const handleChangeUserRole = (e) => {
    setUserRole(e.target.value);
  };
  const handleSelectImg = (imgName) => {
    setProfileImg(imgName);
    const userData = {
      profileImage: imgName,
    };
    dispatch(UsersRequests.updateSingleUser(userData, id));
    setOpenUpdateDialog(false);
  };

  return (
    <CmtCard className={classes.cardRoot}>
      <CmtCardContent className={classes.cardContentRoot}>
        <form className={classes.formContainer} noValidate autoComplete="off">
          <GridContainer className={classes.girdContainer}>
            <Grid item xs={12}>
              <Box className={classes.ProfileImageContainer}>
                <img src={getProfileImage(profileImg)} alt="profileImage" />
                <Box
                  className={classes.editContainer}
                  onClick={() => setOpenUpdateDialog(true)}
                >
                  <Create fontSize="small" />
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} md={6} className={classes.inputContainer}>
              <Typography>شناسه کاربری</Typography>
              <TextField
                id="idInput"
                label="شناسه کاربری"
                variant="outlined"
                className={classes.customInput}
                value={userId}
                onChange={(e) => {}}
              />
            </Grid>
            <Grid item xs={12} md={6} className={classes.inputContainer}>
              <Typography>نام و نام خانوادگی</Typography>
              <TextField
                id="userNameInput"
                label="نام کاربری"
                variant="outlined"
                className={classes.customInput}
                value={userName}
                onChange={(e) => setUserName(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} md={6} className={classes.inputContainer}>
              <Typography>کد ملی</Typography>
              <TextField
                id="nationalCodeInput"
                label="کد ملی"
                variant="outlined"
                className={classes.customInput}
                value={nationalCode}
                onChange={(e) => setNationalCode(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} md={6} className={classes.inputContainer}>
              <Typography>کد پرسنلی</Typography>
              <TextField
                id="personalCodeInput"
                label="کد پرسنلی"
                variant="outlined"
                className={classes.customInput}
                value={personalCode}
                onChange={(e) => setPersonalCode(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} md={6} className={classes.inputContainer}>
              <Typography>شماره تلفن</Typography>
              <TextField
                id="phoneInput"
                label="شماره تلفن"
                variant="outlined"
                className={classes.customInput}
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} md={6} className={classes.inputContainer}>
              <Typography>نسبت</Typography>
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel id="demo-simple-select-outlined-label">
                  نسبت
                </InputLabel>
                <Select
                  labelId="demo-simple-select-outlined-label"
                  id="demo-simple-select-outlined"
                  value={userRole}
                  onChange={handleChangeUserRole}
                  label="نسبت"
                >
                  <MenuItem value={"کارمند فولاد"}>کارمند فولاد</MenuItem>
                  <MenuItem value={"همسر"}>همسر</MenuItem>
                  <MenuItem value={"فرزند دختر"}>فرزند دختر</MenuItem>
                  <MenuItem value={"فرزند پسر"}>فرزند پسر</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6} className={classes.inputContainer}>
              <Typography>نوع همکاری</Typography>
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel id="demo-simple-select-outlined-label">
                  نوع همکاری
                </InputLabel>
                <Select
                  labelId="demo-simple-select-outlined-label"
                  id="demo-simple-select-outlined"
                  value={associationType}
                  onChange={(e) => setAssociationType(e.target.value)}
                  label="نوع همکاری"
                >
                  <MenuItem value={"personnel"}>پرسنل</MenuItem>
                  <MenuItem value={"retired"}>بازنشسته</MenuItem>
                  <MenuItem value={"contractor"}>پیمانکار</MenuItem>
                  <MenuItem value={"saba"}>فولاد صبا</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6} className={classes.inputContainer}>
              <Typography>کلید جفت پوج</Typography>
              <TextField
                id="coinInput"
                label="کلید جفت پوچ"
                variant="outlined"
                className={classes.customInput}
                value={coin}
                onChange={(e) => setCoin(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} md={6} className={classes.inputContainer}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={lock}
                    onChange={(e) => setLock(e.target.checked)}
                    color="primary"
                  />
                }
                label="قطع دسترسی"
              />
            </Grid>
            <Grid item xs={12} md={6} className={classes.inputContainer}>
              <Typography>علت قطع دسترسی</Typography>
              <TextField
                id="coinInput"
                label="علت قطع دسترسی"
                variant="outlined"
                className={classes.customInput}
                value={lockReason}
                onChange={(e) => setLockReason(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} container className={classes.buttonContainer}>
              <Button
                variant="contained"
                color="primary"
                size="medium"
                startIcon={<Create />}
                onClick={handleUpdateUser}
              >
                ویرایش
              </Button>
            </Grid>

            <Grid item xs={12} md={6} className={classes.inputContainer}>
              <Typography>تغییر رمز عبور</Typography>
              <TextField
                id="password"
                label="رمز عبور جدید"
                variant="outlined"
                className={classes.customInput}
                value={passWord}
                onChange={(e) => setPassWord(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} md={6} className={classes.inputContainer}>
              <Typography>تکرار رمز عبور</Typography>
              <TextField
                id="password"
                label="تکرار"
                variant="outlined"
                className={classes.customInput}
                value={passRepeat}
                onChange={(e) => setPassRepeat(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} container className={classes.buttonContainer}>
              <Button
                variant="contained"
                color="primary"
                size="medium"
                startIcon={<Create />}
                onClick={handleUpdatePassword}
              >
                ویرایش
              </Button>
            </Grid>
          </GridContainer>
        </form>
      </CmtCardContent>
      <ChangeProfileDialog
        open={openUpdateDialog}
        handleClose={() => setOpenUpdateDialog(false)}
        action={handleSelectImg}
      />
    </CmtCard>
  );
};

export default UpdateUserContainer;
